import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useAutoId } from './helpers';

Radio.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.any.isRequired,
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  labelHidden: PropTypes.bool,
  children: PropTypes.node.isRequired,
};
export default function Radio({
  name,
  value,
  onChange,
  checked = false,
  disabled = false,
  labelHidden = false,
  children,
}) {
  const autoId = useAutoId('radio');

  return (
    <div className="radio_cover">
      <input
        type="radio"
        id={autoId}
        className="lw_radio"
        name={name}
        value={value}
        onChange={onChange}
        checked={checked}
        disabled={disabled}
      />
      <label htmlFor={autoId} className={classNames({ blind: labelHidden })}>
        {children}
      </label>
    </div>
  );
}
